import useCursorVelocity from "../../hooks/cursorvelocity";

function CursorVelocity() {
  const scrollVelocity = useCursorVelocity();

  return <>Cursor velocity: {scrollVelocity}</>;
}

export default CursorVelocity;
